/** Resultados de visita (misma lista que CRM móvil). */
export const VISITA_RESULTADO_GRUPOS = [
  { id: "cierre", label: "Cierre" },
  { id: "proceso", label: "Sigue en proceso" },
  { id: "objeciones", label: "Objeciones" },
  { id: "descarte", label: "Descarte" },
];

export const VISITA_RESULTADOS = [
  { grupo: "cierre", valor: "Reservado", score: 4 },
  { grupo: "proceso", valor: "Muy interesado", score: 3 },
  { grupo: "proceso", valor: "Segunda visita", score: 3 },
  { grupo: "proceso", valor: "Pasa oferta", score: 3 },
  { grupo: "objeciones", valor: "Precio alto", score: 2 },
  { grupo: "objeciones", valor: "Necesita vender antes", score: 2 },
  { grupo: "objeciones", valor: "Necesita financiación", score: 2 },
  { grupo: "descarte", valor: "No encaja", score: 1 },
  { grupo: "descarte", valor: "Necesita más reforma de lo esperado", score: 1 },
  { grupo: "descarte", valor: "Zona no convence", score: 1 },
  { grupo: "descarte", valor: "Ha encontrado otra", score: 1 },
  { grupo: "descarte", valor: "Ha pausado la búsqueda", score: 1 },
];

export function resultadosPorGrupo(grupoId) {
  return VISITA_RESULTADOS.filter((r) => r.grupo === grupoId);
}
